// @ts-nocheck
import { Layout } from "antd";
import styled from "styled-components";

export const SidebarComponent = styled(Layout.Sider)`
  overflow: auto;
  height: 100vh;
  position: fixed;
  left: 0;
  bottom: 0;
  padding-top: 60px;
  width: ${(props) => (props.isMobile ? "60%" : "200px")} !important;
`;
